(function () {
  'use strict';

  angular
    .module('uwAgenda.settings.agendasettings')
    .controller('DetailAgendaLabelController', [
      'Alert',
      'AgendaLabelService',
      'ItemTableService',
      'SharedAgendaService',
      '$uibModalInstance',
      'label',
      'colors',
      'languages',
      'roles',
      'AgendaLabel',
      'ExternalLocationService',
      DetailAgendaLabelControllerFn
    ]);

  function DetailAgendaLabelControllerFn(
    Alert,
    AgendaLabelService,
    ItemTableService,
	  SharedAgendaService,
    $uibModalInstance,
    label,
    colors,
    languages,
    roles,
	  AgendaLabel,
    ExternalLocationService
  ) {
    var vm = this;

    // current label
    vm.label = {};

    // list of all agenda labels (needed for the 'applicable to label' dropdown)
    vm.labels = [];

    // list of possible colors
    vm.colors = [];
    // list of possible languages
    vm.languages = [];
    // list of possible roles
    vm.roles = [];
    // selected roles
    vm.selectedRoles = [];
    // time preview for user when dayItselfTimeLimit is set
    vm.dayItselfTimeLimitPreview = '';
    // current translation from table
    vm.table = {};

    vm.hasTimeLimit = false;
    vm.locations = [];

    activate();

    // calculate preview of time limit
    vm.dayItselfTimeLimitChanged = function () {
      setDayItselfTimeLimitPreview();

      if (Number.isInteger(vm.label.dayItselfTimeLimit)) {
        vm.hasTimeLimit = true;
      } 
    };

    vm.hasTimeLimitChanged = function() {
      if (!vm.hasTimeLimit) {
        vm.label.dayItselfTimeLimit = null;
      }
    }; 

    vm.selectLocation = function(location) {  
      if (!location.id) {
          vm.label.externalLocation = null;
          vm.label.fK_ExternalLocation = null;    
          return;
      }

      vm.label.externalLocation = location;
      vm.label.fK_ExternalLocation = location.id;
  };


    /* save current item */
    vm.save = function () {
      // prepare for backend
      vm.label.translations = ItemTableService.list();

	  var labelCopy = new AgendaLabel();
	  angular.copy(vm.label, labelCopy);
	  labelCopy.prepareForSave(vm.selectedRoles);
	  
	  // clean sms reminder hours is hidetime is set
      if (labelCopy.hideTime)
      {
        labelCopy.hoursBeforeSMSReminderIsSent = 0;
        labelCopy.sendConfirmationSMSToPatient = false;
      }
      // save or update
      if (vm.label.id > 0) {
        // update
        AgendaLabelService.update(vm.label.id, labelCopy).then(
          function (result) {
            // close modal
            $uibModalInstance.close(result);
            Alert.success('Agenda Label updated successfully');
          },
          function (error) {
            // reload modal view
            $uibModalInstance.dismiss('reload');
          }
        );
      } // if
      else {
        // save
        AgendaLabelService.save(labelCopy).then(
          function (result) {
            // close modal
            $uibModalInstance.close(result);
            Alert.success('Agenda Label saved successfully');
          },
          function (error) {
            // reload modal view
            $uibModalInstance.dismiss('reload');
          }
        );
      } // else
    };

    // close modal
    vm.abort = function () {
      $uibModalInstance.dismiss('abort');
    };

    /* activation work */
    function activate() {
      vm.label = label;
      vm.colors = colors;
      vm.languages = languages;

      vm.hasTimeLimit = Number.isInteger(vm.label.dayItselfTimeLimit);

      initAgendaRoleSelection();

      // set default color if not selected yet
      if (vm.label.fK_Color === null && vm.colors.length > 0) {
        vm.label.fK_Color = vm.colors[0].id; // default first color
      } //if

      // table with translations
      vm.table = ItemTableService.data;

      // calculate time limit preview
      setDayItselfTimeLimitPreview();

      loadLabels();
      loadExternalLocations();
    }

    function loadLabels() {
      var agendaId = SharedAgendaService.data.currentAgenda.id;
      AgendaLabelService.query(agendaId).then(function (labels) {
        vm.labels = labels.filter(function(l) {
			return l.id !== label.id; 
		});
      });
    }

    /* init agenda role array */
    function initAgendaRoleSelection() {
      // role list
      vm.roles = [];
      // roles selected
      vm.selectedRoles = [];

      // roles need to be added as agendaRoles-entities for correct comparison
      for (var i = 0; i < roles.length; i++) {
        var agendaRoleExists = false;
        for (var j = 0; j < vm.label.restrictedRoles.length; j++) {
          if (
            vm.label.restrictedRoles[j].fK_Role === roles[i].id &&
            vm.label.restrictedRoles[j].deleted === false
          ) {
            agendaRoleExists = true;
            vm.roles.push(vm.label.restrictedRoles[j]);
            break;
          } //if
        } //for

        if (agendaRoleExists === false) {
          var agendaRole = {
            fK_Role: roles[i].id,
            role: roles[i],
          };
          vm.roles.push(agendaRole);
        } //if
      } // for

      // selected roles
      for (var k = 0; k < vm.label.restrictedRoles.length; k++) {
        if (
          vm.label.restrictedRoles[k].deleted === 'undefined' ||
          vm.label.restrictedRoles[k].deleted === false
        ) {
          vm.selectedRoles.push(vm.label.restrictedRoles[k]);
        } // if
      } // for
    }

    // set preview date for day itself time limit
    function setDayItselfTimeLimitPreview() {
      vm.dayItselfTimeLimitPreview = '';

      if (!Number.isInteger(vm.label.dayItselfTimeLimit)) {
        return;
      }
    
      var date = new Date();
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);

      date.setHours(date.getHours() + vm.label.dayItselfTimeLimit);

      vm.dayItselfTimeLimitPreview = date;
    }

    function loadExternalLocations() {
      var agendaId = SharedAgendaService.data.currentAgenda.id;
      ExternalLocationService.getAllExternalLocations(agendaId)
          .then(function(locations) {
              locations.unshift({
                  id: null,
                  name: ' - '
              });

              vm.locations = locations;
          });
    }
  }
})();
